module.exports = __webpack_public_path__ + "img/aws-white.9b3d6bcc.svg";